'use client';
import React from 'react';
import Commissions from './Commissions';
import AffiliationsBenefits from './AffiliationsBenefits';
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import AfiwaTag from '@/ui/shared/components/afiwaTag';
import { ArrowRightIcon } from '@heroicons/react/24/outline';
import AfiwaButton from '@/ui/shared/components/afiwaButton';
import PageTitle from '@/ui/shared/components/pageTitle';
import appRoutes from '@/constants/routes';

// IN THE FUTURE GET THIS FROM DATABASE
// DB TABLES : CAMPAIGNS
const minReferals = 2;
const minVolume1 = 100;
const minVolume2 = 150;
const minVolume3 = 200;
const commission1 = 0.1;
const commission2 = 0.15;
const commission3 = 0.2;

function AffiliateProgram() {
  return (
    <>
      <div className="app-container">
        <Section1 />
        <Section2 />
        <Section3 />
        <AffiliationsBenefits />
        <Commissions />
      </div>
    </>
  );
}

export default AffiliateProgram;

function Section1() {
  const t = useTranslations('affiliate_program.heroSection');

  return (
    <div className="mb-20 flex flex-col md:flex-row">
      <div className="my-20 flex flex-1 flex-col items-center">
        <div className="max-w-[600px]  text-center md:ms-10 md:text-left">
          <PageTitle className="font-bold ">
            <span className="text-primary">{t('heading_part_1')}</span>
            <span className="block text-primary-dark">
              {t('heading_part_2')}
            </span>
          </PageTitle>
          <p className=" mt-3 text-[#5C7DAD] md:mb-5">{t('desscription')}</p>

          <AfiwaButton
            type="primary"
            size="large"
            wrapperClass="mt-20"
            href={appRoutes.login}
            text={t('joinProgram')}
            rightIcon={<ArrowRightIcon height={15} width={15} />}
          />
        </div>
      </div>
      <div className="flex flex-1 items-start justify-center">
        <Image src="/affiliate/hero.png" width={500} height={400} alt="hero" />
      </div>
    </div>
  );
}

function Section2() {
  const t = useTranslations('affiliate_program.heroSection');
  return (
    <div className="mb-20 flex flex-col gap-3 text-center md:flex-row md:gap-10 md:text-left">
      <div className="mb-10 w-full  md:ms-10 md:max-w-[300px] xl:ms-20 xl:max-w-[500px]">
        <div className="">
          <h3 className="text-3xl font-bold text-primary md:mb-0">
            <span className="me-1">{t('whoCanJoin')}</span>
            <span className="inline-block whitespace-nowrap">
              {'Afiwa Exchange ?'}
            </span>
          </h3>
        </div>
      </div>

      <div className="flex flex-col  text-[#5C7DAD]">
        <div className="w-full space-y-3 text-sm lg:max-w-[700px]">
          <p className="text-justify">{`${t('point_1')}.`}</p>
          <p className="text-justify">{`${t('point_2')}.`}</p>
          <p className="text-justify">{`${t('point_3')}.`}</p>
        </div>
      </div>
    </div>
  );
}

function Section3() {
  const t = useTranslations('affiliate_program.how_it_works');
  return (
    <div className="mb-20">
      <div className="text-center">
        <div className="flex flex-col   gap-y-10">
          <div className="mx-auto max-w-xs">
            <AfiwaTag text={t('how_it_works')} />
          </div>

          <p className="mx-auto  max-w-sm text-center text-[#5C7DAD]">
            {t('header_description')}
          </p>
        </div>

        <div className="mt-10 flex flex-col gap-2 rounded-[10px] bg-white p-[15px] font-light text-[#03438C]">
          {/* info-1 */}
          <div className="mb-3 flex flex-col border-b pb-2 lg:flex-row">
            {/* 1 */}
            <div className="w-full flex-none pb-3 text-left md:w-[300px]">
              <h5 className="mb-3 font-bold">{t('commission_structure')}</h5>
              <p className="text-sm font-light">
                {t('commission_structure_description')}
              </p>
            </div>
            {/* 2 */}
            <div className="text-light flex flex-col gap-1 text-left text-[10px] sm:text-xs md:flex-row ">
              <div className="flex items-center bg-[#EEFFAA] p-3 text-left">
                <p>
                  <span className="me-1 font-medium">
                    {t('commission_structure_section1_commission', {
                      value1: commission1,
                    })}
                  </span>
                  <span>
                    {t('commission_structure_section1_text', {
                      value1: minVolume1,
                      value2: minVolume2,
                    })}
                  </span>
                </p>
              </div>
              <div className="flex items-center bg-[#FEE8D7] p-3 text-left">
                <p>
                  <span className="me-1 font-medium">
                    {t('commission_structure_section2_commission', {
                      value1: commission2,
                    })}
                  </span>
                  <span>
                    {t('commission_structure_section2_text', {
                      value1: minVolume2 + 1,
                      value2: minVolume3,
                    })}
                  </span>
                </p>
              </div>
              <div className="flex items-center bg-[#DDDDDD]/30 p-3 text-left">
                <p>
                  <span className="me-1 font-medium">
                    {t('commission_structure_section3_commission', {
                      value1: commission3,
                    })}
                  </span>
                  <span>
                    {t('commission_structure_section3_text', {
                      value1: minVolume3 + 1,
                    })}
                  </span>
                </p>
              </div>
            </div>
          </div>
          {/* info-2 */}
          <div className="mb-3 flex flex-col border-b pb-2 lg:flex-row">
            {/* 1 */}
            <div className="w-full flex-none pb-3 text-left md:w-[300px]">
              <h5 className="mb-3 font-bold text-[#03438C]">
                {t('qualification_criteria')}
              </h5>
              <p className="text-sm">
                {t('qualification_criteria_description')}
              </p>
            </div>
            {/* 2  */}
            <div className="text-light flex w-full flex-col gap-1 text-left text-xs md:flex-row">
              <div className="flex items-center bg-[#EEFFAA] p-3">
                {t('qualification_criteria_section1', { value1: minReferals })}
              </div>
              <div className="flex w-full items-center  bg-[#E2CAFF] p-3">
                {t('qualification_criteria_section2')}
              </div>
            </div>
          </div>
          {/* info-3 */}
          <div className="mb-3 flex flex-col border-b pb-2 lg:flex-row">
            {/* 1 */}
            <div className="w-full flex-none pb-3 text-left md:w-[300px]">
              <h5 className="mb-3 font-bold"> {t('commission_payment')}</h5>
              <p className="text-sm font-light">
                {t('commission_payment_description')}
              </p>
            </div>

            {/* 2 */}
            <div className="text-light  flex flex-col gap-1 text-left text-xs   md:flex-row">
              <div className="flex items-center bg-[#EEFFAA] p-3 text-left">
                {t('commission_payment_section1')}
              </div>
              <div className="flex items-center bg-[#FFF4B6] p-3 text-left">
                {t('commission_payment_section2')}
              </div>
              <div className="flex items-center bg-[#DDDDDD]/30 p-3 text-left">
                {t('commission_payment_section3')}
              </div>
            </div>
          </div>
          {/* info-4 */}
          <div className="mb-3 flex flex-col border-b pb-2 lg:flex-row">
            {/* 1 */}
            <div className="w-full flex-none pb-3 text-left md:w-[300px]">
              <h5 className="mb-3 font-bold text-[#03438C]">
                {t('affiliate_dashboard')}
              </h5>
              <p className="text-sm">{t('affiliate_dashboard_description')}</p>
            </div>
            {/* 2 */}
            <div className="text-light flex flex-col text-left text-xs ">
              <div className="flex flex-col gap-1 md:flex-row">
                <div className="flex items-center bg-[#EEFFAA] p-3 text-left">
                  <p>
                    <span className="me-1 font-medium">
                      {t('affiliate_dashboard_section1_title')}
                    </span>
                    <span>{t('affiliate_dashboard_section1_description')}</span>
                  </p>
                </div>
                <div className="flex items-center bg-[#FFF4B6] p-3 text-left">
                  <p>
                    <span className="me-1 font-medium">
                      {t('affiliate_dashboard_section2_title')}
                    </span>
                    <span>{t('affiliate_dashboard_section2_description')}</span>
                  </p>
                </div>
                <div className="flex items-center bg-[#DDDDDD]/30 p-3 text-left">
                  <p>
                    <span className="me-1 font-medium">
                      {t('affiliate_dashboard_section3_title')}
                    </span>
                    <span>{t('affiliate_dashboard_section3_description')}</span>
                  </p>
                </div>
              </div>
              <div className="flex items-center bg-[#E2CAFF] p-3 text-left">
                <p>
                  <span className="me-1 font-medium">
                    {t('affiliate_dashboard_section4_title')}
                  </span>
                  <span>{t('affiliate_dashboard_section4_description')}</span>
                </p>
              </div>
            </div>
          </div>
          {/* info-5 */}
          <div className="flex flex-col lg:flex-row">
            {/* 1 */}
            <div className="w-full flex-none pb-3 text-left md:w-[300px]">
              <h5 className="mb-3 font-bold"> {t('track_progress')}</h5>
              <p className="text-sm font-light">
                {t('track_progress_description')}
              </p>
            </div>
            {/* 2 */}
            <div className="text-light flex flex-col text-left text-xs ">
              <div className="flex flex-col gap-1 md:flex-row">
                <div className="flex items-center bg-[#EEFFAA] p-3 text-left">
                  <p>
                    <span className="me-1 font-medium">
                      {t('track_progress_section1_title')}
                    </span>
                    <span>{t('track_progress_section1_description')}</span>
                  </p>
                </div>
                <div className="flex items-center bg-[#FFF4B6] p-3 text-left">
                  <p>
                    <span className="me-1 font-medium">
                      {t('track_progress_section2_title')}
                    </span>
                    <span>{t('track_progress_section2_description')}</span>
                  </p>
                </div>
                <div className="flex items-center bg-[#DDDDDD]/30 p-3 text-left">
                  <p>
                    <span className="me-1 font-medium">
                      {t('track_progress_section3_title')}
                    </span>
                    <span>{t('track_progress_section3_description')}</span>
                  </p>
                </div>
              </div>
              <div className="w-full flex-grow items-center bg-[#DDDDDD]/30 p-3 text-left">
                <p>
                  <span className="me-1 font-medium">
                    {t('track_progress_section4_title')}
                  </span>
                  <span className="mb-5 block">
                    {t('track_progress_section4_description1')}
                  </span>
                  <span className="block">
                    {t('track_progress_section4_description2')}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
